<template>
  <el-dialog :title="$t('common.confirm')" :visible.sync="visible" width="500px" center @close="close">
    <div class="modal-body">
      <div class="text-center">
        <p>{{ $t('common.confirmExit') }}</p>
        <p class="fee-tip">{{ $t('ownerExitRoom.feeReserveTip') }}</p>
      </div>
      <el-form label-width="120px" class="fee-handle-form">
        <el-form-item :label="$t('ownerExitRoom.feeHandleType')">
          <el-radio-group v-model="feeHandleType" @change="handleFeeHandleChange">
            <el-radio label="KEEP">{{ $t('ownerExitRoom.feeHandleKeep') }}</el-radio>
            <el-radio label="TRANSFER">{{ $t('ownerExitRoom.feeHandleTransfer') }}</el-radio>
            <el-radio label="WRITE_OFF">{{ $t('ownerExitRoom.feeHandleWriteOff') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="feeHandleType === 'TRANSFER'" :label="$t('ownerExitRoom.transferOwner')">
          <el-input v-model="transferOwnerName" :placeholder="$t('ownerExitRoom.transferOwnerPlaceholder')" readonly class="transfer-owner-input"></el-input>
          <el-button type="primary" size="small" @click="selectTransferOwner">{{ $t('common.select') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="doOwnerExitRoom">{{ $t('common.confirm') }}</el-button>
    </div>
    <search-owner ref="searchTransferOwner" @chooseOwner="handleChooseTransferOwner"></search-owner>
  </el-dialog>
</template>

<script>
import { exitRoom } from '@/api/owner/showOwnerRoomApi'
import { getCommunityId } from '@/api/community/communityApi'
import SearchOwner from '@/components/owner/SearchOwner'

export default {
  name: 'OwnerExitRoom',
  components: {
    SearchOwner
  },
  data() {
    return {
      visible: false,
      roomInfo: {},
      feeHandleType: 'KEEP',
      transferOwnerId: '',
      transferOwnerName: ''
    }
  },
  methods: {
    open(roomInfo) {
      this.roomInfo = roomInfo
      this.feeHandleType = 'KEEP'
      this.transferOwnerId = ''
      this.transferOwnerName = ''
      this.visible = true
    },
    close() {
      this.visible = false
      this.roomInfo = {}
    },
    selectTransferOwner() {
      this.$refs.searchTransferOwner.open()
    },
    handleChooseTransferOwner(owner) {
      const currentOwnerIds = [this.roomInfo.ownerId, this.roomInfo.ownerMemberId].filter(item => item)
      const transferOwnerIds = [owner.ownerId, owner.memberId].filter(item => item)
      const transferOwnerId = owner.ownerId || owner.memberId
      if (transferOwnerIds.some(item => currentOwnerIds.includes(item))) {
        this.$message.error(this.$t('ownerExitRoom.validate.transferOwnerSame'))
        return
      }
      this.transferOwnerId = transferOwnerId
      this.transferOwnerName = owner.name
    },
    handleFeeHandleChange(value) {
      if (value !== 'TRANSFER') {
        this.transferOwnerId = ''
        this.transferOwnerName = ''
      }
    },
    async doOwnerExitRoom() {
      if (this.feeHandleType === 'TRANSFER' && !this.transferOwnerId) {
        this.$message.error(this.$t('ownerExitRoom.validate.transferOwnerRequired'))
        return
      }

      try {
        const params = {
          ...this.roomInfo,
          communityId: getCommunityId(),
          feeHandleType: this.feeHandleType,
          transferOwnerId: this.transferOwnerId,
          transferOwnerName: this.transferOwnerName
        }

        const res = await exitRoom(params)
        if (res.code === 0) {
          this.$emit('success')
          this.close()
          this.$message.success(this.$t('ownerExitRoom.exitSuccess'))
        } else {
          this.$message.error(res.msg || this.$t('ownerExitRoom.exitFailed'))
        }
      } catch (error) {
        this.$message.error(error.message || this.$t('ownerExitRoom.requestFailed'))
      }
    }
  }
}
</script>

<style scoped>
.modal-body {
  padding: 20px;
  text-align: center;
}

.text-center {
  text-align: center;
}

.dialog-footer {
  text-align: center;
}

.fee-tip {
  color: #e6a23c;
  font-size: 12px;
  margin-top: 10px;
}

.fee-handle-form {
  margin-top: 16px;
  text-align: left;
}

.transfer-owner-input {
  width: 220px;
  margin-right: 10px;
}
</style>
